export default __webpack_public_path__ + "static/media/folding-fan.3451edc2.svg";